import { render, staticRenderFns } from "./CampaignRevenue.vue?vue&type=template&id=67a56e96&scoped=true"
import script from "./CampaignRevenue.vue?vue&type=script&lang=ts"
export * from "./CampaignRevenue.vue?vue&type=script&lang=ts"
import style0 from "./CampaignRevenue.vue?vue&type=style&index=0&id=67a56e96&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a56e96",
  null
  
)

export default component.exports